import React, {
  useEffect,
  useState,
  useRef,
  Dispatch,
  SetStateAction,
} from 'react';
import {
  View,
  TouchableOpacity,
  Pressable,
  RefreshControl,
  KeyboardAvoidingView,
  Platform,
  Keyboard,
  VirtualizedList,
  useWindowDimensions,
  Image
} from 'react-native';
import { useIsFocused } from '@react-navigation/native';
import Popover from 'react-native-popover-view';
import { Theme, ThemeConsumer } from '@rneui/themed';
import moment from 'moment';
import { getScreenPermission, useAppDispatch, useAppSelector } from '../../../redux/hooks';
import { appColors, fontSize } from 'zen-core-elements/src/shared/constants';
import { ZenRBSheetRef } from 'zen-core-elements/src/elements/zenRBSheet/RBSheet';
import {
  ChosenImageDetailsInterface,
  StorageLimitResponse,
  StoreImageItem,
} from './ImageGallery.model';
import { downloadFile, ZenBadge, ZenText, ZenButton, ZenDivider, ZenDropdown, ZenEmptyComponent, ZenFilterModal, ZenIcon, ZenInput, ZenLoader, ZenRBSheet, ZenSearchBar, ZenToast } from 'zen-core-elements';
import { bulkDeleteImage, getAllStoreImages, getImageProperty, getStoreageAvailability, updateImageDetail, clearCache } from '../../../redux/slices/imageGallerySlice';
import CommonService from '../../../shared/services/commonService';
import { config } from '../../../shared/environment';
import CommonDialogBox from '../../../shared/commonComponents/commonDialogBox';
import { filterItemsProps } from 'zen-core-elements/src/elements/zenFilterModal/zenFilterType.modal';
import { useAppRoute } from '../../../types/@react-navigation/navigation';
import Toast from 'react-native-toast-message';
import Video from 'react-native-video';
import { ZenToastConfig } from 'zen-core-elements/src/elements/ZenToastMessage/zenToast';
import { CustomModal } from '../../../shared/commonComponents/customModal';
import { useKeyborad } from '../../../shared/hooks/useKeyborad';
import CommonSortModal from '../../../shared/commonComponents/commonSortModal';
import CommonImagePicker, { commonPickerRes } from '../../../shared/commonComponents/commonImageUpload';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { shallowEqual } from 'react-redux';

type ImageGalleryProps = {
  type?: string;
  multi?: "single" | number;
  isImagePicker?: boolean;
  setImageIsVisible?: Dispatch<SetStateAction<boolean>>;
  onCloseStoreImageGallery?: (val: any[]) => void;
  isImage?: boolean
};


// Functional Component to display Store Image Gallery
const StoreImageGallery = ({
  onCloseStoreImageGallery,
  isImagePicker,
  multi,
  setImageIsVisible,
  type,
  isImage = true,
}: ImageGalleryProps) => {
  const dispatch = useAppDispatch();
  const isKeyboardOpen = useKeyborad();
  const { isWrite: isImageGalleryWrite } = useAppSelector(getScreenPermission("ImageGalleryStack"), shallowEqual)
  const bottomRef = useRef<ZenRBSheetRef>(null)

  const { currentUser } = useAppSelector(state => state.common);
  // Variable used to store route data from useRoute hook
  const isReadOnly = useAppRoute("ImageGalleryStack")?.params?.isReadOnly;
  const [isSortVisible, setIsVisibleSort] = useState(false)
  //variable to open/close the bottom sheet
  const refOpenActions = useRef<ZenRBSheetRef>(null);
  //Reference variable to find the page is focused
  const isFocused = useIsFocused();
  const insets = useSafeAreaInsets()
  const isMounted = useRef(false);
  const isRefreshing = useRef(false);
  const { width, height } = useWindowDimensions();
  //variable which is used to store the chosen tab
  const [chosenTab, setChosenTab] = useState<string>(
    type ? type : 'Products',
  );
  //variable which is used to store the image list
  const [imageList, setImageList] = useState<StoreImageItem[]>([]);
  //variable which is used to maintain the activity indicator
  const [load, setLoad] = useState<boolean>(true);
  //variable which is used to store the chosen sort value
  const [chosenSort, setChosenSort] = useState<{ label: string, id: number } | null>(null);
  //variable which is used to store the search text
  const [search, setSearch] = useState<string | null>(null);
  //variable which is used to open/close the popover and modal
  const [openConfirmation, setOpenConfirmation] = useState('');
  //state which is used to store the multiple select product
  const [multipleImages, setMultipleImages] = useState<any[]>([]);
  const [selectedImages, setSelectedImages] = useState<string[]>([])
  //variable is used to control the refresh controller state
  const [refresh, setRefresh] = useState(false);
  //variable to maintain the keyboard open and close
  const [keyboardOpen, setKeyboardOpen] = useState(false);
  //variable which is used to disable the searchbar and filter
  const [isDisable, setIsDisable] = useState(false);
  //variable to store the count val
  const [count, setCount] = useState<number>(0)
  //variable is used to open/close the popover
  const [openPopover, setOpenPopover] = useState({
    popover: false,
    tabValue: '',
  });

  //variable is used to store the plan storage limit values
  const [storageLimit, setStorageLimit] = useState<
    StorageLimitResponse['storageIsInLimit'] | null
  >(null);
  //variable is used to store the image properties
  const [imageProperty, setImageProperty] = useState<{
    fileType: string[] | undefined;
    chosenFileType: string | null;
    chosenFileSize: string | null;
    openFilterType: boolean;
    openFileSize: boolean;
    openFilter: boolean;
    appliedFilterValues: { fileSize: string; fileType: string; category?: string } | null;
  }>({
    fileType: [''],
    chosenFileType: null,
    chosenFileSize: null,
    openFilterType: false,
    openFileSize: false,
    openFilter: false,
    appliedFilterValues: null,
  });

  //variable to store the current image details
  const [chosenImageDetails, setChosenImageDetails] = useState<ChosenImageDetailsInterface>({
    info: null,
    dirtyPopover: false,
    openPopover: false,
    renameText: '',
    renameFieldTouched: false,
    buttonLoader: false,
    openViewPopover: false,
  });
  //variable to set the footer loader
  const [limit, setLimit] = useState(false);
  //variable to store the search and original images list
  const [resultArray, setResultArray] = useState<StoreImageItem[]>([]);
  //variable to store the search result list
  const [searchData, setSearchData] = useState<StoreImageItem[]>([]);

  //variable which is used to list of sort options
  const sortArray = [
    { value: 1, label: 'Image Name A-Z', id: 1 },
    { value: 2, label: 'Image Name Z-A', id: 2 },
    { value: 3, label: 'Latest First', id: 3 },
    { value: 4, label: 'Oldest First', id: 4 },
  ];

  const imageCategoryDropdownData = [
    { label: 'Products', value: 'products' },
    { label: 'Brands', value: 'brands' },
    { label: 'Categories', value: 'categories' },
    { label: 'Blog', value: 'blog' },
    { label: 'Gift Cards', value: 'giftcards' },
  ];
  const [imageUploadCategoryValue, setImageUploadCategoryValue] = useState<string | null>(type ? type : 'products',);
  const [imageUploadCategoryOpen, setImageUploadCategoryOpen] =
    useState<boolean>(false);

  const [filterData, setFilterData] = useState<filterItemsProps[]>([])

  //variable to store the image list actions
  const listActions: { title: string; icon: { name: string }; onPress: () => void }[] = [
    ...isImageGalleryWrite ? [{
      title: 'Edit',
      icon: { name: 'pencil-outline' },
      onPress: () => {
        refOpenActions?.current?.close();
        setTimeout(() => {
          setChosenImageDetails(prev => {
            let value = { ...prev };
            value.openPopover = true;
            return value;
          });
        }, 100);
      },
    }] : [],
    {
      title: 'View',
      icon: { name: 'clock-time-three-outline' },
      onPress: () => {
        refOpenActions?.current?.close();
        setTimeout(() => {
          setChosenImageDetails(prev => {
            let value = { ...prev };
            value.openViewPopover = true;
            return value;
          });
        }, 100);
      },
    },
    ...isImageGalleryWrite ? [{
      title: 'Remove',
      icon: { name: 'delete-outline' },
      onPress: () => {
        refOpenActions?.current?.close();
        setTimeout(() => {
          setOpenConfirmation('deleteConfirmation');
        }, 100);
      },
    }] : [],
    {
      title: 'Download',
      icon: { name: 'cloud-download-outline' },
      onPress: () => {
        refOpenActions?.current?.close();
        setTimeout(() => {
          downloadImages();
        }, 100);
      },
    },
  ];

  //variable which is used to display the warning message for delete popover
  const deleteDialogProps = {
    content:
      'Do you want to delete the selected images even if it is already used?',
    button: [
      {
        id: 1,
        name: 'Yes',
      },
      {
        id: 2,
        name: 'No',
      },
    ],
    image: { iconName: 'delete-outline', color: appColors?.darkRed },
  };
  // Variable to hold the path of the noImage
  const noImg = 'mobileAdmin/no-image.jpg';
  //State variable used to store leave page dialogbox props
  const leaveDialogProps = {
    content: 'Are you sure you want to leave this page?',
    button: [
      {
        id: 1,
        name: 'Stay',
      },
      {
        id: 2,
        name: 'Leave Page',
      },
    ],
    image: { iconName: 'run', color: appColors.primary },
  };

  //useEffect to initialize page listeners and fetch formats/storage limit on focus
  useEffect(() => {
    if (isFocused) {
      Keyboard.addListener('keyboardDidShow', () => {
        setKeyboardOpen(true);
      });
      Keyboard.addListener('keyboardDidHide', () => {
        setKeyboardOpen(false);
      });
      setLoad(true);
      if (!isImagePicker) {
        getImageFileFormat();
      } else {
        getImages()
      }
    }
  }, [isFocused]);

  //useEffect to call the getImages function when sort, tab or filter value changes
  useEffect(() => {
    if (isMounted.current) {
      if (isRefreshing.current) {
        return;
      }
      getImages();
    } else {
      isMounted.current = true;
    }
  }, [imageProperty?.appliedFilterValues, chosenSort, chosenTab]);

  useEffect(() => {
    let searchData = search ? imageList?.filter((val) => ((val?.Key?.split("/", 3)[2]).toLowerCase()).includes(search ? search.toLowerCase() : '')) : imageList
    let sliceData = searchData.slice(0, 12)
    setSearchData([...searchData])
    setResultArray([...sliceData])
  }, [search])

  const handleCategoryChange = (newCategory: string) => {
    if (chosenTab.toLowerCase() !== newCategory.toLowerCase()) {
      if (multipleImages?.length > 0) {
        setOpenPopover({
          popover: true,
          tabValue: newCategory,
        });
      } else {
        setLoad(true);
        setSearchData([]);
        setResultArray([]);
        setChosenSort(null);
        setSearch(null);
        setMultipleImages([]);
        setSelectedImages([]);
        setChosenTab(newCategory);
        setImageUploadCategoryValue(newCategory);
        setImageProperty(prev => {
          let val = { ...prev };
          val.chosenFileSize = null;
          val.chosenFileType = null;
          val.openFilterType = false;
          val.openFileSize = false;
          val.openFilter = false;
          val.appliedFilterValues = {
            fileSize: "",
            fileType: "",
            category: newCategory,
          };
          return val;
        });
      }
    }
  };

  const getFilterItems = () => {
    let items = isImage ? [...filterData] : [];
    if (width < height && !isImagePicker) {
      const categoryFilter: filterItemsProps = {
        id: '3',
        filterName: 'Category',
        filterType: 'radio',
        filterValue: imageCategoryDropdownData,
        initialSelected: chosenTab.toLowerCase(),
      };
      items = [categoryFilter, ...items];
    }
    return items;
  };

  const getFilterBadgeCount = () => {
    let count = 0;
    if (imageProperty?.appliedFilterValues?.fileSize) count++;
    if (imageProperty?.appliedFilterValues?.fileType) count++;
    if (width < height && !isImagePicker) {
      count++;
    }
    return count;
  };

  const getImageFileFormat = async () => {
    await dispatch(getImageProperty())
      .unwrap()
      .then(response => {
        if (response?.success) {
          const formats = response?.response?.rows[0]?.additionalField?.imgFormat || [];
          setFilterData(() => {
            const fileFormatFilter: filterItemsProps = {
              filterName: "File Type",
              filterType: "radio",
              id: "1",
              initialSelected: "",
              filterValue: formats.map(format => ({
                value: format,
                label: format
              }))
            };

            const fileSizeFilter: filterItemsProps = {
              id: '2',
              filterName: 'File Size',
              filterType: "radio",
              filterValue: [
                { label: "< 1mb", value: "1" },
                { label: '1mb < 2mb', value: "2" },
                { label: '2mb < 3mb ', value: "3" },
                { label: '3mb < 4mb', value: "4" },
                { label: '4mb < 5mb', value: "5" }
              ],
              initialSelected: ''
            };

            return [fileFormatFilter, fileSizeFilter];
          });
          setImageProperty(val => {
            let temp = { ...val };
            temp.fileType = response?.response?.rows[0]?.additionalField?.imgFormat;
            return temp;
          });
          getStoreageAvailable();
        }
      }).catch((err) => {
        setLoad(false);
        ZenToast({ message: err?.response?.data?.message, type: "error" })
      })
  };

  //method to get the image list based on the selected tab
  const getStoreageAvailable = async () => {

    await dispatch(getStoreageAvailability())
      .unwrap()
      .then(storageRes => {
        if (storageRes && storageRes?.storageIsInLimit) {
          setStorageLimit(storageRes?.storageIsInLimit);
          getImages();
        }
      }).catch(err => {
        setLoad(false);
        ZenToast({ message: err?.response?.data?.message, type: "error" })
      })

  };
  // helper to sort list of StoreImageItem
  const sortImages = (images: StoreImageItem[], sortOption: { label: string, id: number } | null) => {
    if (!sortOption?.label) return images;
    const sorted = [...images];
    if (sortOption.label === 'Image Name A-Z' || sortOption.label === 'Image Name Z-A') {
      const sortOrder = sortOption.label === 'Image Name A-Z' ? 1 : -1;
      sorted.sort((a, b) => {
        const keyA = (a.Key || '').split('/', 3)[2] || '';
        const keyB = (b.Key || '').split('/', 3)[2] || '';
        return sortOrder * keyA.toLowerCase().localeCompare(keyB.toLowerCase());
      });
    } else if (sortOption.label === 'Latest First' || sortOption.label === 'Oldest First') {
      const sortOrder = sortOption.label === 'Latest First' ? 1 : -1;
      sorted.sort((a, b) =>
        sortOrder * (new Date(b.LastModified).getTime() - new Date(a.LastModified).getTime())
      );
    }
    return sorted;
  };

  //method to get the images
  const getImages = async (
    overrideFileType?: string | null,
    overrideFileSize?: string | null,
    overrideSort?: { label: string; id: number } | null
  ) => {
    const fileTypeToUse = overrideFileType !== undefined ? overrideFileType : imageProperty?.chosenFileType;
    const fileSizeToUse = overrideFileSize !== undefined ? overrideFileSize : imageProperty?.chosenFileSize;
    const sortToUse = overrideSort !== undefined ? overrideSort : chosenSort;

    let data: {
      imageDirectory: string;
      format?: string[];
      size?: number;
    } = {
      imageDirectory:
        'STORE_' +
        currentUser?.value?.store?.id +
        '/' +
        chosenTab.toLowerCase() +
        '/',
    };
    if (fileTypeToUse) {
      data['format'] = [fileTypeToUse];
    }

    if (!isImage) {
      data['format'] = ['mp4'];
    }

    if (fileSizeToUse)
      data['size'] = Number(fileSizeToUse);

    await dispatch(getAllStoreImages(data))
      .unwrap()
      .then((res) => {
        if (res && res?.storeImages) {
          const allowedImageExtensions: string[] = [
            'png',
            'jpg',
            'gif',
            'jpeg',
            'heic',
            'webp',
          ];
          let filteredImages: StoreImageItem[];
          if (isImage) {
            filteredImages = res?.storeImages?.filter((val: any) =>
              allowedImageExtensions.includes(val?.Key?.split('.')?.[1])
            )?.map((image: any) => {
              const formattedUrl = image?.Key ? CommonService?.imageConversion(image?.Key) : undefined;
              return {
                ...image,
                formattedUrl,
              };
            });
          } else {
            filteredImages = res.storeImages;
          }

          // Apply sorting on the entire list of fetched images before paginating
          if (sortToUse !== null) {
            filteredImages = sortImages(filteredImages, sortToUse);
          }

          setIsDisable(
            search === null &&
            (overrideFileType !== undefined ? overrideFileType == null : imageProperty?.appliedFilterValues == null) &&
            (!filteredImages || filteredImages?.length === 0),
          );

          let temp = filteredImages.slice(0, 12);
          setImageList(filteredImages);

          setResultArray(temp);
          setTimeout(() => {
            setLoad(false);
            setRefresh(false);
            isRefreshing.current = false;
          }, 100);
        }
      })
      .catch(err => {
        setLoad(false);
        setRefresh(false);
        isRefreshing.current = false;
        console.log('error in get item', err?.message);
        ZenToast({ message: err?.response?.data?.message || err?.message, type: 'error' });
      });
  };

  //remove image
  const deleteStoreImage = async () => {
    setLoad(true);
    await dispatch(bulkDeleteImage({
      storeId: currentUser?.value?.store?.id!, data: {
        keys: multipleImages?.length ? multipleImages : selectedImages,
      }
    })).unwrap().then(res => {
      if (res) {
        ZenToast({ message: `${isImage ? "Image" : "Video"} data removed successfully`, type: "success" })
        setMultipleImages([]);
        setSelectedImages([]);
        getImageFileFormat();
      }
    })
      .catch(err => {
        setLoad(false);
        ZenToast({ message: 'Failed to delete the data.', type: "error" })
        getImageFileFormat();
        console.log('error in bulk delete', err);
      });
  };

  //method to download the images
  const downloadImages = async () => {
    await downloadFile({
      fileName: chosenImageDetails?.info?.formattedUrl!,
      fileUrl: config?.AWSImageUrl + chosenImageDetails?.info?.formattedUrl!,
    }).then(response => {
      ZenToast({ message: 'Download completed successfully.', type: "success" })
    })
      .catch(err => {
        console.log('Error in downloading image', err);
        ZenToast({ message: 'Error in downloading image.', type: "error" })
      });
  };

  //method to rename image name
  const renameImage = async () => {
    setChosenImageDetails(prev => {
      let value = { ...prev };
      value.buttonLoader = true;
      return value;
    });
    let payload = {
      name: chosenImageDetails?.renameText?.trim()!,
      key: chosenImageDetails?.info?.Key!,
    };
    await dispatch(updateImageDetail({ storeId: currentUser?.value?.store?.id!, data: payload })).unwrap().then(res => {

      if (res && res?.deletedImagesCount) {
        setChosenImageDetails(prev => {
          let value = { ...prev };
          value.buttonLoader = false;
          value.openPopover = false;
          value.renameFieldTouched = false;
          value.renameText = '';
          return value;
        });
        setLoad(true);
        ZenToast({ message: `${isImage ? "Image" : "Video"} name updated successfully!`, type: "success" })
        getImages();
      }
    })
      .catch(err => {
        ZenToast({ message: 'Failed to rename the data.', type: "error" })
        setChosenImageDetails(prev => {
          let value = { ...prev };
          value.buttonLoader = false;
          return value;
        });
        console.log('err in updateImageDetail', err);
      });
  };

  //method to perform the refresh controller
  const onRefresh = () => {
    dispatch(clearCache());
    setRefresh(true);
    isRefreshing.current = true;
    setSearch(null);
    setSearchData([]);
    setResultArray([]);
    setChosenSort(null);
    setCount(0);
    setImageProperty(prev => ({
      ...prev,
      chosenFileSize: null,
      chosenFileType: null,
      openFileSize: false,
      openFilter: false,
      openFilterType: false,
      appliedFilterValues: null,
    }));
    setMultipleImages([]);
    setSelectedImages([]);
    setFilterData(prev =>
      prev.map(item => ({
        ...item,
        initialSelected: '',
      }))
    );

    dispatch(getStoreageAvailability())
      .unwrap()
      .then(storageRes => {
        if (storageRes && storageRes?.storageIsInLimit) {
          setStorageLimit(storageRes?.storageIsInLimit);
        }
      })
      .catch(() => { });

    getImages(null, null, null);
  };

  //method to calculate the images count
  const getBadgeCount = () => {
    let listCount = (search ? searchData : imageList)?.length;
    if (listCount <= 1000) {
      return listCount;
    } else {
      return '1000+';
    }
  };

  const handleImage = (name: string, res?: commonPickerRes[]) => {
    if ((name === 'Library') && res && res.length > 0) {
      bottomRef?.current?.close()
      setLoad(true)
      dispatch(clearCache());
      setTimeout(() => getImages(), 100);
    } else if (name === "Cancel") {
      bottomRef?.current?.close()
    }
  };

  //method to perform the confirmation
  const confirmation = (value: { id: number, name: string }) => {
    if (value?.name == 'Yes') {
      deleteStoreImage();
      setOpenConfirmation('');
    } else {
      setOpenConfirmation('');
    }
  };

  // method to perform the leave confirmation
  const leaveConfirmation = (value: { id: number, name: string }) => {
    if (value?.name == 'Leave Page') {
      if (chosenImageDetails?.dirtyPopover) {
        setChosenImageDetails(prev => {
          let value = { ...prev };
          value.openPopover = false;
          value.dirtyPopover = false;
          value.renameText = '';
          return value;
        });
      } else {
        setLoad(true);
        setChosenSort(null);
        setSearch(null);
        setMultipleImages([]);
        setSelectedImages([]);
        setChosenTab(openPopover?.tabValue);
        setImageUploadCategoryValue(openPopover?.tabValue);
        setOpenPopover({ popover: false, tabValue: '' });
        setImageProperty(prev => {
          let val = { ...prev };
          val.chosenFileSize = null;
          val.chosenFileType = null;
          val.openFilterType = false;
          val.openFileSize = false;
          val.openFilter = false;
          val.appliedFilterValues = {
            fileSize: "",
            fileType: "",
            category: openPopover?.tabValue,
          };
          return val;
        });
      }
    } else {
      setChosenImageDetails(prev => {
        let value = { ...prev };
        value.dirtyPopover = false;
        return value;
      });
      setOpenPopover({ popover: false, tabValue: '' });
    }
  };

  //method to perform the onPress
  const getSingleData = (item: StoreImageItem) => {
    if (!isImagePicker) {
      if (multipleImages?.length > 0) {
        if (
          multipleImages?.find(
            val => val == item?.Key) == undefined) {
          setMultipleImages((prevFilter) => {
            return prevFilter?.filter(
              element => element == item?.Key).length > 0
              ? prevFilter
              : [
                ...prevFilter,
                item?.Key
              ];
          });
          setSelectedImages((prevFilter) => {
            return prevFilter?.filter(
              element => element == item?.Key).length > 0
              ? prevFilter
              : [
                ...prevFilter,
                item?.Key
              ];
          });
        } else {
          if (multipleImages.length > 0) {
            setMultipleImages((prevFilter) => {
              return prevFilter.filter(
                element =>
                  element == item?.Key
              ).length > 0
                ? prevFilter.filter(
                  ele =>
                    ele != item?.Key
                )
                : [
                  ...prevFilter, item?.Key
                ];
            });
            setSelectedImages((prevFilter) => {
              return prevFilter.filter(
                element =>
                  element == item?.Key
              ).length > 0
                ? prevFilter.filter(
                  ele =>
                    ele != item?.Key
                )
                : [
                  ...prevFilter, item?.Key
                ];
            });
          }
        }
      } else {
        setMultipleImages([item?.Key])
        setSelectedImages([item?.Key])
        setChosenImageDetails(prev => {
          let value = { ...prev };
          value.info = item;
          value.buttonLoader = false;
          value.renameFieldTouched = false;
          value.renameText = '';
          return value;
        });
        refOpenActions?.current?.open();
      }
    } else {

      if (multi != 'single') {
        if (multipleImages?.find(val => val?.Key == item?.Key) == undefined) {
          if (multipleImages?.length >= multi!) {
            ZenToast({ message: `Products ${isImage ? "image" : "video"} count reached the maximum limit!`, type: "error" })
          } else {
            setMultipleImages(prevFilter => {
              return prevFilter.filter(element => element == item?.Key)
                .length > 0
                ? prevFilter
                : [...prevFilter, item];
            });
            setSelectedImages(prevFilter => {
              return prevFilter.filter(element => element == item?.Key)
                .length > 0
                ? prevFilter
                : [...prevFilter, item?.Key];
            });
          }
        }
        else {
          if (multipleImages?.length > 0) {
            const isSelected = multipleImages.some(image => image?.Key === item?.Key);
            if (isSelected) {
              setMultipleImages(prev => prev.filter(img => img?.Key !== item?.Key));
              setSelectedImages(prev => prev.filter(key => key !== item?.Key));
            } else {
              setMultipleImages(prev => [...prev, item]);
              setSelectedImages(prev => [...prev, item?.Key]);
            }
          }
        }
      } else {
        onCloseStoreImageGallery!([item]);
      }
    }
  };

  //method to perform the on long select
  const onMultipleSelect = (item: StoreImageItem) => {
    if (!isImagePicker) {
      const productKey = item?.Key;
      setMultipleImages(prevFilter => {
        const isSelected = prevFilter.includes(productKey);
        if (!isSelected) {
          return [...prevFilter, productKey];
        } else if (prevFilter.length > 0) {
          return prevFilter.filter(ele => ele !== productKey);
        }
        return prevFilter;
      });
      setSelectedImages(prevFilter => {
        const isSelected = prevFilter.includes(productKey);
        if (!isSelected) {
          return [...prevFilter, productKey];
        } else if (prevFilter.length > 0) {
          return prevFilter.filter(ele => ele !== productKey);
        }
        return prevFilter;
      });
    }
  };

  //Function used to render image items
  const renderItem = ({ item, index }: { item: StoreImageItem[], index: number }) => {
    return (
      <ThemeConsumer>
        {({ theme }: { theme: Theme }) => (
          <View key={index} style={{ flexDirection: 'row', flex: 1 }}>
            {item?.map((itemValue, key) => (
              <View
                key={key}
                style={[
                  theme.storeImageGalleryStyle.renderItemContainer,
                  { flex: width > 1024 ? 1 / 4 : width > height ? 1 / 3 : 0.5 },
                ]}>
                <Pressable
                  key={key}
                  onPress={() => {
                    if (!isReadOnly) {
                      getSingleData(itemValue);
                    }
                  }}
                  onLongPress={() => {
                    if (!isReadOnly) onMultipleSelect(itemValue);
                  }}>
                  <View
                    style={{
                      borderColor:
                        isImagePicker && multipleImages?.find(val => val?.Key == itemValue?.Key) != undefined
                          ? theme.primary
                          : !isImagePicker &&
                            multipleImages?.find(val => val == itemValue?.Key) != undefined
                            ? theme.activeColor
                            : theme.borderColor,
                      borderWidth: 1,
                      borderRadius: 8,
                      marginHorizontal: 5,
                      padding: 8,
                      marginTop: 0,
                    }}>
                    {isImagePicker &&
                      multipleImages?.find(val => val == itemValue?.Key) !=
                      undefined && (
                        <View
                          style={{
                            position: 'absolute',
                            alignSelf: 'flex-end',
                            backgroundColor: appColors.primary,
                            height: 15,
                            width: 15,
                            borderRadius: 15,
                            alignItems: 'center',
                            justifyContent: 'center',
                            top: -3,
                            right: -3,
                          }}>
                          <ZenIcon
                            type='material-community'
                            name="check"
                            size={10}
                            color={theme.light}
                          />
                        </View>
                      )}

                    <View style={{ alignItems: 'center' }}>
                      <Image
                        style={theme.storeImageGalleryStyle.imageStyle}
                        source={{
                          uri:
                            config.AWSImageUrl +
                            (!isImage ? (itemValue?.thumbnail ? itemValue?.thumbnail
                              : noImg) : itemValue?.formattedUrl
                              ? itemValue?.formattedUrl
                              : noImg)
                        }}
                        onError={() => {
                          setResultArray(prev =>
                            prev?.map(item =>
                              item?.imgKey === itemValue?.imgKey
                                ? {
                                  ...item,
                                  formattedUrl:
                                    itemValue?.Key /* Key: null */,
                                }
                                : item,
                            ),
                          );
                        }}
                      />
                      <ZenDivider style={theme.storeImageGalleryStyle.divider} />
                    </View>
                    <ZenText
                      bold
                      content={itemValue?.Key?.split('/', 3)[2]}
                      ellipsizeMode="tail"
                      numberOfLines={1}
                      style={[
                        theme.storeImageGalleryStyle.itemnamestyle,
                        { fontSize: fontSize?.tinyFontSize },
                      ]} />
                    <View style={{ marginVertical: 5 }}>
                      <View
                        style={[
                          theme.storeImageGalleryStyle.renderSubView,
                          { alignItems: 'center' },
                        ]}>
                        <ZenText
                          content={"Size"}
                          color={appColors.lightFontColor}
                          style={[
                            { fontSize: fontSize?.tinyFontSize, textAlign: 'right', flexWrap: 'wrap' },
                          ]} />
                        <ZenText
                          content={(itemValue?.Size / 1000).toFixed(2) + ' KB'}
                          color={appColors.lightDark}
                          bold
                          style={[
                            { fontSize: fontSize?.tinyFontSize, textAlign: 'right', flexWrap: 'wrap' },
                          ]} />

                      </View>
                      <View
                        style={
                          theme.storeImageGalleryStyle.uploadImageContainer
                        }>
                        <ZenIcon
                          type='material-community'
                          name="calendar-import"
                          size={16}
                          color={theme.lightFontColor}
                        />
                        <ZenText
                          content={moment(itemValue?.LastModified).format(
                            'MMM DD, YYYY',
                          )}
                          bold
                          color={appColors.lightDark}
                          size={fontSize?.tinyFontSize}
                          style={[
                            {
                              fontSize: fontSize?.tinyFontSize,
                              textAlign: 'left',
                              marginLeft: 5,
                              flexWrap: 'wrap'
                            },
                          ]} />

                      </View>
                    </View>
                  </View>
                </Pressable>
              </View>
            ))}
          </View>
        )}
      </ThemeConsumer>
    );
  };

  // Function used to Render Footer
  const RenderFooter = () => {
    return (
      <ThemeConsumer>
        {({ theme }) =>
          limit ? (
            <ZenLoader size="small" color={theme.primary} />
          ) : null
        }
      </ThemeConsumer>
    );
  };

  const getFlex = () => {
    if (search == null)
      if (imageList?.length == 0) return 1;
      else return undefined;
    else if (searchData?.length == 0) return 1;
    else return undefined;
  };

  //render component
  return (
    <ThemeConsumer>
      {({ theme }) => (
        <KeyboardAvoidingView
          behavior={Platform.OS === 'ios' ? 'padding' : undefined}
          enabled
          onStartShouldSetResponder={() => {
            setImageUploadCategoryOpen(false)
            return false
          }}
          style={{ ...theme.storeImageGalleryStyle.flex, paddingTop: isImagePicker ? insets?.top : 0 }}>
          {/* render header */}
          {isImagePicker ? (
            <View style={{ flexDirection: "row", alignItems: "center", justifyContent: "space-between", padding: 10, paddingBottom: 0 }}>
              <ZenText content='Store Image Gallery' bold size={"large"} />
              <ZenIcon type='material-community' name='close' color={appColors.iconColor} onPress={() => setImageIsVisible!(false)} />
            </View>
          ) : undefined}
          {/* render search bar */}
          <View
            onStartShouldSetResponder={() => {
              Keyboard.dismiss();
              return false;
            }}
            style={[
              theme.storeImageGalleryStyle.searchbarView,
              {
                gap: width > height ? 15 : 10,
                alignItems: imageUploadCategoryOpen ? 'flex-start' : 'center',
              },
              imageUploadCategoryOpen && {
                height: 180,
                marginBottom: -130,
              }
            ]}
          >

            <View style={{ flex: 1 }}>
              <ZenSearchBar
                placeholder={isImage ? "Image Name" : "Video Name"}
                search={search!}
                onCancel={() => {
                  if (!isKeyboardOpen) {
                    Keyboard.dismiss();
                  }
                  setSearch("")
                }}
                setSearch={(text) => {
                  const resolved = typeof text === 'function' ? text(search || '') : text;
                  setSearch(resolved);
                }}
                searchIcon={{ name: 'search', type: 'evilicon', size: width > height ? 25 : 20, color: appColors.grey }}
                leftIconContainerStyle={{ justifyContent: 'center', paddingRight: 10 }}
              />
            </View>
            {width > height ? <>
              {!isImagePicker ? <View style={{
                width: 150,
                zIndex: 1000,
                height: imageUploadCategoryOpen ? 180 : undefined,
              }}>
                <ZenDropdown
                  items={imageCategoryDropdownData}
                  value={imageUploadCategoryValue}
                  maxHeight={130}
                  onSelectItem={({ value }) => {
                    if (chosenTab != value) {
                      if (multipleImages?.length > 0) {
                        setOpenPopover({
                          popover: true,
                          tabValue: value as string,
                        });
                      } else {
                        setLoad(true);
                        setSearchData([]);
                        setResultArray([]);
                        setChosenSort(null);
                        setSearch(null);
                        setMultipleImages([]);
                        setSelectedImages([]);
                        setChosenTab(value as string);
                        setImageProperty(prev => {
                          let val = { ...prev };
                          val.chosenFileSize = null;
                          val.chosenFileType = null;
                          val.openFileSize = false;
                          val.openFilter = false;
                          val.openFilterType = false;
                          val.appliedFilterValues = null;
                          return val;
                        });
                      }
                    }
                  }}
                  setValue={setImageUploadCategoryValue}
                  open={imageUploadCategoryOpen}
                  setOpen={setImageUploadCategoryOpen}
                  labelStyle={{ fontSize: fontSize.smallFontSize }}
                  placeholderStyle={{ fontSize: fontSize.smallFontSize }}
                  listItemLabelStyle={{
                    fontSize: fontSize.smallFontSize,
                  }}
                />
              </View> : undefined}
              {/* Render Badge */}
              {!isImagePicker ? <View style={{ marginLeft: 5 }}>
                <ZenBadge
                  badgeColor={appColors.green}
                  badgeName={`${getBadgeCount()} ${isImage ? "image(s)" : "video(s)"}`}
                  badgeTextColor={appColors.light}
                  badgeTextSize={"medium"}
                  badgeContainerStyle={{ paddingVertical: 4 }}
                />
              </View> : undefined}
            </> : undefined}
            <TouchableOpacity
              disabled={isDisable || resultArray?.length == 0}
              onPress={() => setIsVisibleSort(true)}
              style={[{
                backgroundColor: theme.light,
                paddingVertical: 7,
                paddingHorizontal: 7,
                borderRadius: 7,
                borderColor: theme.light,
                borderWidth: 1,
                justifyContent: 'center',
                alignItems: 'center',
              }]}
            >
              <ZenIcon
                type='material'
                name="swap-vert"
                size={21}
                color={
                  isDisable || resultArray?.length == 0
                    ? theme.grey
                    : theme.iconColor
                }
              />
            </TouchableOpacity>
            {(isImage || (width < height && !isImagePicker)) ? (
              <View style={{ position: 'relative' }}>
                <TouchableOpacity
                  onPress={() => {
                    setImageProperty((prev) => {
                      let val = { ...prev }
                      val.openFilter = true
                      val.openFileSize = false
                      val.openFilterType = false
                      val.chosenFileSize = val?.appliedFilterValues?.fileSize ? val.appliedFilterValues?.fileSize : null
                      val.chosenFileType = val.appliedFilterValues?.fileType ? val.appliedFilterValues?.fileType : null
                      return val
                    })
                  }}
                  style={{
                    backgroundColor: theme.light,
                    paddingVertical: 7,
                    paddingHorizontal: 7,
                    borderRadius: 7,
                    borderColor: theme.light,
                    borderWidth: 1,
                    justifyContent: 'center',
                    alignItems: 'center',
                  }}
                >
                  <ZenIcon type='material-community' name='tune-variant'
                    disabled={isDisable && !(width < height && !isImagePicker)}
                    color={(isDisable && !(width < height && !isImagePicker)) ? theme.grey : theme.iconColor}
                    size={width > height ? 22 : 18}
                  />
                  {/* Badge */}
                  {!!getFilterBadgeCount() && getFilterBadgeCount() > 0 && (
                    <View style={{
                      position: 'absolute',
                      top: -4,
                      right: -4,
                      height: 18,
                      minWidth: 18,
                      borderRadius: 9999,
                      backgroundColor: theme.secondary,
                      justifyContent: 'center',
                      alignItems: 'center',
                      paddingHorizontal: 2,
                    }}>
                      <ZenText content={getFilterBadgeCount() > 9 ? '9+' : getFilterBadgeCount()} bold color={theme?.light} size={theme?.badgeFontSize} />
                    </View>
                  )}
                </TouchableOpacity>

              </View>
            ) : undefined}
          </View>
          <View style={theme.storeImageGalleryStyle.container}>


            {!isImagePicker && !load && width < height ? (
              <View style={[theme.storeImageGalleryStyle.storeImageHeader, { justifyContent: 'space-between', paddingHorizontal: 15, marginTop: 10 }]}>
                <ZenText
                  content={chosenTab}
                  size={fontSize?.largerFontSize}
                  bold
                  color={appColors.primary}
                  style={[theme.storeImageGalleryStyle.storeImageHeaderText, { fontSize: fontSize?.largerFontSize, borderBottomWidth: 0, textTransform: 'capitalize' }]}
                />
                <ZenBadge
                  badgeName={`${getBadgeCount()} ${isImage ? "image(s)" : "video(s)"}`}
                  badgeTextColor={appColors.light}
                  badgeTextSize={"medium"}
                  badgeContainerStyle={{ paddingVertical: 4, borderRadius: 15 }}
                  badgeColor={appColors?.green}
                />
              </View>
            ) : undefined}

            {isImagePicker && !load ?
              <View style={theme.storeImageGalleryStyle.storeImageHeader}>
                <ZenText
                  content={type?.substring(0, type?.length - 1) + ' Images'}
                  size={fontSize?.largerFontSize}
                  bold
                  color={appColors.primary}
                  style={[theme.storeImageGalleryStyle.storeImageHeaderText, { fontSize: fontSize?.largerFontSize }]} />
                <ZenBadge
                  badgeName={getBadgeCount() as string}
                  badgeTextColor={appColors.light}
                  badgeTextSize={"medium"}
                  badgeContainerStyle={{ paddingVertical: 4, borderRadius: 15 }}
                  badgeColor={appColors?.secondary}
                />
              </View>
              : undefined
            }

            {/* render loader and flatlist */}
            <View
              style={[
                theme.storeImageGalleryStyle.flatlistView,
                { marginTop: isImagePicker ? 4 : 10 },
              ]}>
              {load ? (
                <ZenLoader
                  lottieType='Local'
                  lottie={require("../../../assets/infinityLoader.json")}
                  style={{
                    justifyContent: 'center',
                    alignItems: 'center',
                    flex: 1,
                  }}
                />
              ) : (
                <VirtualizedList
                  data={resultArray}
                  initialNumToRender={10}
                  showsVerticalScrollIndicator={false}
                  ListFooterComponentStyle={{ height: 50 }}
                  ListFooterComponent={<RenderFooter />}
                  ListEmptyComponent={
                    refresh ? undefined : isDisable ? (
                      <ZenEmptyComponent
                        text={
                          `No ${isImage ? "images" : "videos"} are available for ` +
                          chosenTab?.toLowerCase()
                        }
                      />
                    ) : (
                      <ZenEmptyComponent text={`No ${isImage ? "images" : "videos"} found`} />
                    )
                  }
                  renderItem={renderItem}
                  keyExtractor={(item, index) => index.toString()}
                  getItemCount={data => data?.length}
                  getItem={(data, index) => {
                    let items = [];
                    let numColumns = width > 1024 ? 4 : width > height ? 3 : 2;
                    for (let i = 0; i < numColumns; i++) {
                      const item = data[index * numColumns + i];
                      item && items.push(item);
                    }
                    return items;
                  }}
                  onEndReached={() => {
                    if (
                      (search ? searchData : imageList)?.length > 0 &&
                      resultArray?.length > 0 &&
                      resultArray?.length <=
                      (search ? searchData : imageList)?.length
                    ) {
                      setLimit(true);
                      setTimeout(() => {
                        let slicedArray = (
                          search ? searchData : imageList
                        ).slice(resultArray?.length, resultArray?.length + 8); //11 20
                        setResultArray(prev => [...prev, ...slicedArray]);
                        setLimit(false);
                      }, 100);
                    }
                  }}
                  // contentContainerStyle={{ flex: ((search ? searchData : imageList)?.length == 0) ? 1 : null, paddingBottom: 40 }}
                  contentContainerStyle={{ flex: getFlex(), paddingBottom: 40 }}
                  refreshControl={
                    <RefreshControl
                      refreshing={refresh}
                      onRefresh={onRefresh}
                    />
                  }
                />
              )}
            </View>
            {/* renders bulk delete icon */}
            {multipleImages?.length > 0 && !keyboardOpen ? (
              <View style={theme.storeImageGalleryStyle.deleteIconView}>
                <ZenIcon
                  type='material-community'
                  name="delete"
                  size={30}
                  color={theme.light}
                  onPress={() => {
                    setOpenConfirmation('deleteConfirmation');
                  }}
                />
              </View>
            ) : null}

            {/* render add button */}
            {!load &&
              multipleImages?.length == 0 &&
              !isImagePicker &&
              !keyboardOpen &&
              !isReadOnly &&
              storageLimit?.status && isImageGalleryWrite && (
                <View
                  style={{
                    alignSelf: 'flex-end',
                    backgroundColor: appColors.primary,
                    borderRadius: 50,
                    alignItems: 'center',
                    justifyContent: 'center',
                    height: 55,
                    width: 55,
                    position: 'absolute',
                    bottom: 25,
                    right: 25,
                  }}>
                  <TouchableOpacity
                    onPress={() => {
                      setTimeout(() => {
                        bottomRef?.current?.open()
                      }, 100);
                    }}>
                    <ZenIcon
                      type='material-community'
                      name="plus"
                      size={30}
                      color={theme.light}
                    />
                  </TouchableOpacity>
                </View>
              )}
            {multi != 'single' &&
              isImagePicker &&
              multipleImages?.length > 0 &&
              !keyboardOpen && (
                <View
                  style={[
                    theme.storeImageGalleryStyle.addIconView,
                    { backgroundColor: theme.primary },
                  ]}>
                  <TouchableOpacity
                    onPress={() => {
                      onCloseStoreImageGallery!(multipleImages);
                      setImageIsVisible!(false);
                    }}>
                    <ZenIcon
                      type='material-community'
                      name="check"
                      size={30}
                      color={theme.light}
                    />
                  </TouchableOpacity>
                </View>
              )}
            {multi != 'single' &&
              isImagePicker &&
              multipleImages?.length > 0 &&
              !keyboardOpen ? (
              <View
                style={{
                  alignSelf: 'flex-end',
                  backgroundColor: appColors.lightPrimary,
                  borderRadius: 20 / 2,
                  alignItems: 'center',
                  justifyContent: 'center',
                  height: 20,
                  width: 20,
                  position: 'absolute',
                  bottom: 65,
                  right: 23,
                }}>
                <ZenText
                  content={multipleImages?.length}
                  bold
                  color={appColors.primary}
                  size={14}
                />

              </View>
            ) : null}

            {/* bottom sheet to perform the list actions */}
            <ZenRBSheet
              ref={refOpenActions}
              draggable={true}
              closeOnPressMask={true}
              onClose={() => setMultipleImages([])}
              customStyles={{
                container: { borderTopLeftRadius: 20, borderTopRightRadius: 20 },
              }}
              height={width > 600 ? 270 : 260}
              children={
                <View style={{ flex: 1, backgroundColor: appColors.light }}>
                  <View style={{ paddingTop: 3, paddingBottom: 13 }}>
                    <ZenText
                      content={chosenImageDetails?.info?.Key?.split('/', 3)[2]}
                      bold
                      size={fontSize?.largerFontSize}
                      color={appColors.lightDark}
                      ellipsizeMode="tail"
                      numberOfLines={1}
                      style={{
                        marginHorizontal: 25,
                        textAlign: 'center',
                        flexWrap: 'wrap',
                      }} />
                  </View>
                  <ZenDivider style={{ marginBottom: 3 }} />
                  {listActions.map((item, key) => (
                    <Pressable onPress={item?.onPress} key={key}>
                      <View
                        style={{
                          flexDirection: 'row',
                          alignItems: 'center',
                          paddingLeft: 20,
                          paddingVertical: 12,
                        }}>
                        <ZenIcon
                          type='material-community'
                          name={item?.icon?.name}
                          color={theme.bottomSheetIcon}
                          size={20}
                          style={{ paddingLeft: 10 }}
                        />
                        <ZenText
                          content={item?.title}
                          size={fontSize?.mediumFontSize}
                          color={appColors.lightDark}
                          style={[
                            {
                              paddingLeft: 15,
                              textAlign: 'center',
                            },
                          ]} />
                      </View>
                    </Pressable>
                  ))}
                </View>
              }
            />




            {/* popover for remove confirmation */}
            <Popover
              isVisible={openConfirmation == 'deleteConfirmation'}
              popoverStyle={{ width: width > 600 ? 400 : 300, borderRadius: 10 }}>
              <CommonDialogBox
                type='OTHER'
                dialog={deleteDialogProps}
                confirmation={confirmation}
              />
            </Popover>

            {/* Confirmation Dialog view for leaving the page*/}
            <Popover
              isVisible={openPopover?.popover}
              popoverStyle={{
                width: width > 900 ? 600 : width > 600 ? 500 : 300,
                borderRadius: 10,
                paddingBottom: 35,
              }}>
              <CommonDialogBox
                type='OTHER'
                dialog={leaveDialogProps}
                confirmation={leaveConfirmation}
              />
            </Popover>

            {/* render filter modal */}
            {((filterData?.length > 0 && isImage) || (width < height && !isImagePicker && (!isImage || filterData?.length > 0))) ? <ZenFilterModal
              setVisible={(visible) => setImageProperty(prev => ({ ...prev, openFilter: typeof visible === 'function' ? visible(prev.openFilter) : visible }))}
              visible={imageProperty?.openFilter}
              filterItems={getFilterItems()}
              filterCount={count}
              setFilterCount={setCount}
              setFilterItems={(updatedItems) => {
                const resolved = typeof updatedItems === 'function' ? updatedItems(getFilterItems()) : updatedItems;
                const cleaned = resolved.filter(item => item.filterName !== "Category");
                setFilterData(cleaned);
              }}
              onConfirm={(value) => {
                const selectedCategory = value?.values["Category"];
                if (selectedCategory && selectedCategory.toLowerCase() !== chosenTab.toLowerCase()) {
                  handleCategoryChange(selectedCategory);
                  setImageProperty(prev => ({ ...prev, openFilter: false }));
                } else {
                  setLoad(true);
                  setImageProperty(prev => {
                    let val = { ...prev };
                    val.appliedFilterValues = {
                      fileType: value?.values["File Type"] || "",
                      fileSize: value?.values["File Size"] || "",
                      category: selectedCategory || chosenTab.toLowerCase(),
                    }
                    val.chosenFileSize = value?.values["File Size"] || ""
                    val.chosenFileType = value?.values["File Type"] || ""
                    val.openFilter = false;
                    return val;
                  });
                }
              }}
              title="Store Image Gallery Filter" /> : undefined}
            {/* render edit image modal */}
            <CustomModal animationType='slide' transparent={true} visible={chosenImageDetails?.openPopover}>
              <View style={{ flex: 1, justifyContent: 'center', alignItems: 'center', backgroundColor: appColors.transparentBackground }}>
                <View style={[{ width: width > 900 ? 600 : width > 600 ? 500 : 350, backgroundColor: appColors.light, borderRadius: 15 }]}>
                  <View style={[{ paddingVertical: 13, paddingHorizontal: 15, backgroundColor: appColors.lightBackgroundColor, justifyContent: 'space-between', flexDirection: 'row', borderRadius: 10 }]}>
                    <ZenText
                      content={"Edit Image"}
                      color={appColors.primary}
                      size={fontSize?.largerFontSize}
                      bold
                      style={{ textAlign: "left" }} />
                    <ZenIcon type='ionicon' name='close-circle' color={theme.iconColor} size={width > 600 ? 24 : 22} onPress={() => {
                      if (chosenImageDetails?.renameText?.length! > 0) {
                        setChosenImageDetails((prev) => {
                          let value = { ...prev }
                          value.dirtyPopover = true
                          return value
                        })
                      }
                      else
                        setChosenImageDetails((prev) => {
                          let value = { ...prev }
                          value.openPopover = false
                          value.renameText = null
                          return value
                        })
                    }} />
                  </View>
                  <View style={theme.storeImageGalleryStyle.renameTextView}>
                    <ZenInput
                      label={'Rename *'}
                      maxLength={250}
                      value={chosenImageDetails?.renameText ? chosenImageDetails?.renameText : ''}
                      inputStyle={theme?.modifierSetStyle?.inputStyle}
                      errorStyle={{ fontSize: theme?.errorFontSize, fontFamily: theme?.medium, color: theme?.red, }}
                      type="outlined"
                      containerStyle={{ paddingHorizontal: 15, }}
                      inputContainerStyle={{ paddingHorizontal: 8 }}
                      onChangeText={(text: string) => {
                        setChosenImageDetails((prev) => {
                          let value = { ...prev }
                          value.renameText = text
                          return value
                        })
                      }}
                      onBlur={() => {
                        setChosenImageDetails((prev) => {
                          let value = { ...prev }
                          value.renameFieldTouched = true
                          value.renameText = value.renameText ? value?.renameText?.trim() : ''
                          return value
                        })
                      }}
                      errorMessage={chosenImageDetails?.renameFieldTouched && chosenImageDetails?.renameText?.length == 0 ? "Rename is required" : undefined}
                      labelStyle={theme?.addEditCustomerStyle?.labelStyle}
                    />
                    <ZenButton title={'Update'}
                      containerStyle={theme.storeImageGalleryStyle.buttonContainer}
                      loading={chosenImageDetails?.buttonLoader}
                      disabled={chosenImageDetails?.renameText?.length == 0}
                      onPress={() => { renameImage() }}
                      buttonStyle={{ backgroundColor: appColors.primary, width: width > 600 ? 130 : 120 }}
                      titleStyle={[theme.storeImageGalleryStyle.buttonText, { fontSize: fontSize?.smallerFontSize }]}
                    />
                  </View>

                </View>
                {/* Confirmation Dialog view for leaving the page*/}
                <Popover isVisible={chosenImageDetails?.dirtyPopover} popoverStyle={{ width: width > 900 ? 600 : width > 600 ? 500 : 300, borderRadius: 10, paddingBottom: 35 }}>
                  <CommonDialogBox type='OTHER' dialog={leaveDialogProps} confirmation={leaveConfirmation} />
                </Popover>
              </View>
            </CustomModal>

            {/* popover for view images */}
            <Popover
              isVisible={chosenImageDetails?.openViewPopover}
              popoverStyle={{
                width: width > 900 ? 620 : width > 600 ? 520 : 340,
                borderRadius: 10,
                paddingBottom: 10,
              }}>
              <View
                style={[
                  {
                    padding: 13,
                    backgroundColor: appColors.lightBackgroundColor,
                    justifyContent: 'space-between',
                    flexDirection: 'row',
                    marginBottom: 8,
                  },
                ]}>
                <ZenText
                  content={`View ${isImage ? "Image" : "Video"}`}
                  color={appColors.primary}
                  size={fontSize?.largerFontSize}

                  bold
                  style={{ textAlign: "left" }} />

                <ZenIcon
                  type='ionicon'
                  name="close-circle"
                  color={theme.iconColor}
                  size={width > 600 ? 24 : 22}
                  onPress={() => {
                    setChosenImageDetails(prev => {
                      let value = { ...prev };
                      value.openViewPopover = false;
                      return value;
                    });
                  }}
                />
              </View>
              <View style={theme.storeImageGalleryStyle.cameraContainerStyle}>
                {isImage ? <Image
                  source={{
                    uri:
                      config.AWSImageUrl +
                      (chosenImageDetails?.info?.Key
                        ? chosenImageDetails?.info?.Key
                        : noImg),
                  }}
                  style={theme.storeImageGalleryStyle.viewImageStyle}
                  resizeMode={'contain'}
                /> : (
                  <Video
                    source={{
                      uri: config.AWSImageUrl +
                        (chosenImageDetails?.info?.Key
                          ? chosenImageDetails?.info?.Key
                          : noImg)
                    }}
                    style={{ width: '100%', height: width > 600 ? 350 : 250 }}
                    controls={true}
                    resizeMode="contain"
                  />
                )}
              </View>
            </Popover>
          </View>
          <CommonSortModal
            selectedId={chosenSort?.id}
            visible={isSortVisible}
            options={sortArray}
            onSelect={(item) => {
              setChosenSort({ label: item?.label!, id: item?.id! })
              setIsVisibleSort(false)
            }}
            onClose={() => setIsVisibleSort(false)}
            title='Sort by'
          />
          <CommonImagePicker
            bottomRef={bottomRef}
            propFn={handleImage}
            gallery={{
              isStoreGallery: false,
              isVideo: !isImage,
              sectionName: chosenTab == 'Categories' ? 'category' : chosenTab?.toLowerCase(),
              screenName: 'imageGallery',
            }}
            selectedIndex={{ value: { imagesMaxLength: isImage ? 100 : 10 } }}
          />

          <Toast config={ZenToastConfig} position='bottom' bottomOffset={30} />
        </KeyboardAvoidingView>
      )}

    </ThemeConsumer>
  );
};

export default StoreImageGallery;
